import { render } from "./DatetimeField.vue?vue&type=template&id=96b1cf9a"
import script from "./DatetimeField.vue?vue&type=script&lang=js"
export * from "./DatetimeField.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__